import {
  CassandraConfigDTO,
  ElasticConfigDTO,
  EntityGroupConfigDTO,
  MaintainConfigDTO,
  MenuType,
  TickerConfigDTO,
} from '../../system/system-dtos';

export class MenuUtils {
  public static getFirstTickerConfig(entityGroup: EntityGroupConfigDTO): TickerConfigDTO {
    return this.getWIthTypeAndIndex(entityGroup, 0, MenuType.TICKER);
  }

  public static getFirstMaintainConfig(entityGroup: EntityGroupConfigDTO): MaintainConfigDTO {
    return this.getWIthTypeAndIndex(entityGroup, 0, MenuType.MAINTAIN);
  }

  public static getFirstElasticConfig(entityGroup: EntityGroupConfigDTO): ElasticConfigDTO {
    return this.getWIthTypeAndIndex(entityGroup, 0, MenuType.ELASTIC);
  }

  public static getFirstCassandraConfig(entityGroup: EntityGroupConfigDTO): CassandraConfigDTO {
    return this.getWIthTypeAndIndex(entityGroup, 0, MenuType.CASSANDRA);
  }

  public static getNthConfigAsElastic(entityGroup: EntityGroupConfigDTO, index: number): ElasticConfigDTO {
    return this.getWIthIndex(entityGroup, index);
  }

  public static getNthConfigAsCassandra(entityGroup: EntityGroupConfigDTO, index: number): CassandraConfigDTO {
    return this.getWIthIndex(entityGroup, index);
  }

  private static getWIthTypeAndIndex(entityGroup: EntityGroupConfigDTO, index: number, menuType: MenuType): any {
    const maintainDataSources = entityGroup.dataSources.filter((ds) => ds.type === menuType);
    return maintainDataSources.length < index + 1 ? null : maintainDataSources[index].definition;
  }

  private static getWIthIndex(entityGroup: EntityGroupConfigDTO, index: number): any {
    const theIndex = index || 0;
    const maintainDataSources = entityGroup.dataSources;
    return maintainDataSources.length < theIndex + 1 ? null : maintainDataSources[theIndex].definition;
  }
}
